import { Component, ViewChild, inject } from '@angular/core';
import { FormInput, FormHandlingComponent, PageComponent, PageService, NoticeService, FormComponent } from '@tytapp/common';
import { GiftsApi, ApiGiftItem, UsersApi, ApiGiftRedemption, ApiUser, ApiUserAuthToken } from '@tytapp/api';
import { UserService } from '@tytapp/user';
import { ActivatedRoute } from '@angular/router';
import { Validated, SevenCharacterLength, NonEmptyValidator, EmailValidator } from 'validation';

@Component({
  selector: 'app-gift-redemption',
  templateUrl: './gift-redemption.component.html',
  styleUrls: ['./gift-redemption.component.scss']
})
export class GiftRedemptionComponent extends PageComponent implements FormHandlingComponent {
  private userApi = inject(UsersApi);
  private notices = inject(NoticeService);
  private giftsApi = inject(GiftsApi);
  private userService = inject(UserService);
  private route = inject(ActivatedRoute);

  user: ApiUser;
  giftItem: ApiGiftItem;
  code: string;
  submitting: boolean;

  @Validated({ class: EmailValidator, field: 'email' })
  @FormInput()
  email: string = "";

  @Validated({ class: NonEmptyValidator, field: 'recipient-name' })
  @FormInput()
  recipient_name: string = "";

  @Validated({ class: SevenCharacterLength, field: 'password' })
  @FormInput()
  password : string = "";

  @Validated({ class: SevenCharacterLength, field: 'confirm-password' })
  @FormInput()
  confirmPassword: string = '';

  @Validated({ class: NonEmptyValidator, field: 'username' })
  @FormInput()
  username: string = '';

  message: string = '';
  existingEmailError: boolean = false;
  alreadyHasMembership = false;

  async init() {
    this.subscribe(this.userService.userChanged, async user => {
      this.user = user;
      this.alreadyHasMembership = false;
      if (this.user && this.user.membership && this.user.membership.active) {
        this.alreadyHasMembership = true;
      }
    });

    this.subscribe(this.route.params, async params => {
      if (params.code) {
        this.code = params.code;
        try {
          this.giftItem = await this.giftsApi.getGiftItem(this.code).toPromise();
          console.log('giftitem: ', this.giftItem);
          if (!this.giftItem.sponsorship) {
            this.email = this.giftItem.recipient_email;
            this.recipient_name = this.giftItem.recipient_name;
          }
        } catch(e) {
          this.router.navigate(['/account']);
        }
      } else {
        this.router.navigate(['/account']);
      }
    })
  }

  get themeUrl() {
    if (this.giftItem.theme_name === 'cenk') {
      return '/assets/redemption/cenk.jpg';
    }
    if (this.giftItem.theme_name === 'ana') {
      return '/assets/redemption/ana.png';
    }
    if (this.giftItem.theme_name === 'john') {
      return '/assets/redemption/john.jpg';
    }
    if (this.giftItem.theme_name === 'jayar') {
      return '/assets/redemption/jayar.jpeg';
    }
    return '/assets/redemption/mariguana.jpg';
  }

  // get giftDuration() {
  //   if (this.giftItem.recurring) {
  //     return this.giftItem.product_sku.split('_')[1] === 'annually' ? 'annual': 'monthly';
  //   } else {
  //     return `${this.giftItem.months} months`;
  //   }
  // }

  get giftProductName() {
    let split = this.giftItem.product_sku.split('_');
    let periodMap = {
      annually: 'annual'
    };
    let duration = this.giftItem.months ? `${this.giftItem.months} Months` : this.capitalizeFirstLetter(periodMap[split[1]] || split[1]);
    return `${this.capitalizeFirstLetter(split[0])} (${duration})`;
  }

  @ViewChild('form')
  form: FormComponent;

  async submit() {
    if (!this.form.validate()) {
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.showError('Passwords don\'t match. Make sure both Password fields match so you can access your new account!');
      return;
    }

    this.submitting = true;

    // field error show up for confirm password

    try {
      let userAuthToken : ApiUserAuthToken = await this.userApi.signup({
        app: 'accounts',
        flow: 'gift-redemption',
        email: this.email,
        username: this.username,
        password: this.password,
        first_name: this.recipient_name,
        email_marketing_optin: false,
        source: this.userService.source || `gift-redemption`,
        source_first_time: this.userService.sourceFirstTime
      }).toPromise();

      let user : ApiUser = userAuthToken;

      if (userAuthToken.token) {
        this.userService.completeLogin(user, userAuthToken.token, false, () => {
          this.redeemGift();
        });
      } else {
        this.shell.alert(
          'Confirm your Account to login',
          `
            Your account has been created, but you must confirm your account before you login.
            Please check your email and follow the instructions we've sent.
          `
        );
        this.submitting = false;
      }

    } catch (e) {
      if (e.json)
        e = e.json();

      console.dir(e);
      this.submitting = false;
      if (e.code === 'email_exists') {
        this.existingEmailError = true;
      } else {
        this.showError(e.message || e.error);
      }
    }

  }


  async redeemGift() {
    let redemption : ApiGiftRedemption;
    this.submitting = true;
    try {
      redemption = await this.giftsApi.giftRedemption(this.code, { message: this.message }).toPromise();
      if (redemption.is_redeemed) {
        let item = this.giftItem.sponsorship ? 'sponsorship' : 'gift';
        this.notices.post(`Your ${item} is redeemed!`, 'success');
        this.router.navigate(['/account']);
      }
    } catch(e) {
      let error = e.json();
      this.submitting = false;
      this.showError(error.message || error.error);
    }
  }

  get welcome() {
    if (!this.giftItem.sponsorship) {
      return `Welcome ${this.capitalizeFirstLetter(this.giftItem.recipient_name)}!`
    }
    if (this.giftItem.sponsorship && this.user && this.user.profile) {
      return `Welcome ${this.user.profile.first_name}!`
    }
    return 'Welcome!';
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


}
